import { cva } from "class-variance-authority";

/**
 * Shared visual contract for date and time availability controls.
 *
 * Available options use the darker cream surface. Selection is always the
 * teal action color, so availability and selection are never conflated.
 */
export const availabilityOptionVariants = cva(
  "inline-flex items-center justify-center border text-sm font-medium transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-brand-action focus-visible:ring-offset-2 focus-visible:ring-offset-background",
  {
    variants: {
      state: {
        available:
          "border-input bg-secondary text-foreground hover:border-brand-action",
        selected:
          "border-brand-action bg-brand-action text-brand-foreground hover:bg-brand-action-hover",
        unavailable:
          "cursor-not-allowed border-transparent bg-transparent text-muted-foreground",
      },
    },
    defaultVariants: {
      state: "available",
    },
  },
);

export const availabilityOptionMetaVariants = cva("text-[11px]", {
  variants: {
    state: {
      available: "text-muted-foreground",
      selected: "text-brand-foreground/80",
      unavailable: "text-muted-foreground",
    },
  },
  defaultVariants: {
    state: "available",
  },
});
